export const FIT_ATTRIBUTE_TYPE = 'Fit';
export const LOWER_FIT_ATTRIBUTE_TYPE = 'LowerFit';

export type AttributeTypeT =
    | 'Text'
    | 'Number'
    | 'Size'
    | 'Material'
    | typeof FIT_ATTRIBUTE_TYPE
    | typeof LOWER_FIT_ATTRIBUTE_TYPE;
